import { getUser, setUser } from '@utils/storage.js';
import { UPDATEUER } from '../type';
export default {
  namespaced: true,
  state: {
    // 默认取sesstionstorage中的用户信息, 如果没有数据则为 ''
    userInfo: getUser()
  },
  mutations: {
    [UPDATEUER] (state, userInfo) {
      // 合并用户信息
      state.userInfo = Object.assign({}, state.userInfo, userInfo);
      // 保存到sesstionstorage
      setUser(state.userInfo);
    }
  },
  actions: {
    updateUser ({ commit }, userInfo) {
      commit(UPDATEUER, userInfo);
    }
  }
};



// WEBPACK FOOTER //
// ./src/vuex/modules/user.js